import { attachmentsConstants, parentTypesDeletingURL } from "../constants/attachments.constants";
import { authHeader } from '../helpers/auth-header';
import { client } from './';

const url = '/Request';

export const attachmentsActions = {
    fetchAttachments,
    fetchAttachment,
    deleteAttachment,
    deleteOneAttachment,
    previewAttachment,
    openAttachment,
};

async function previewAttachment(id, fileName, where) {
    const rurl = (where && where == 'documents')
        ? '/docs/attachment?docId=' + id + '&filename=' + fileName
        : '/Request/attachment?requestid=' + id + '&filename=' + fileName
    const response = await client.get(rurl, { headers: authHeader() })
        if(response.status == 200){
            const data = Buffer.from(response.data, "base64");
            return window.URL.createObjectURL(new Blob([data]));
        }
        else return null
}


async function openAttachment(id, fileName, attachName, where) {
    const rurl = (where && where == 'documents')
        ? '/docs/attachment?docId=' + id + '&filename=' + fileName
        : '/Request/attachment?requestid=' + id + '&filename=' + fileName
        return client.get(rurl, { headers: authHeader() }).then( response => {
            let data = Buffer.from(response.data, "base64");
            const url = window.URL.createObjectURL(new Blob([data], {type: 'application/pdf'} ));
            const link = document.createElement('a');
            link.href = url;
            const w = window.open(url);
            setTimeout(()=>{w.document.title = attachName}, 500);
        })
}

function fetchAttachment(id, fileName, attachName, where) {
    const rurl = (where && where == 'documents')
        ? '/docs/attachment?docId=' + id + '&filename=' + fileName
        : '/Request/attachment?requestid=' + id + '&filename=' + fileName
    return client.get(rurl, { headers: authHeader() }).then( response => {
        let data = Buffer.from(response.data, "base64");
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', attachName);
        document.body.appendChild(link);
        link.click();
    })
}

function deleteAttachment(id, attachId, where) {
	let url = parentTypesDeletingURL[where];
	if (where === "docsComment") {
		url = url + attachId;
	} else {
		url = url + id;
	}
	return client.delete(url, {
		headers: authHeader(),
		params: {
			attachId: where === "docsComment" ? undefined : attachId,
		},
	});
}

function deleteOneAttachment(id, attachId) {
    const rurl = '/Request/attachment?requestid=' + id + '&attachId=' + attachId
        return client.delete(rurl, { headers: authHeader() })
}

function fetchAttachments(id, where) {
  let url = `/Request/request_attachments/${id}`;
  if (where === 'documents') {
    url = `/docs/attachments/${id}`;
  }
  return client.get(url, { headers: authHeader()});
}
